// extracted by mini-css-extract-plugin
module.exports = {"insightPost":"InsightPost__insightPost__WAIag","userInfo":"InsightPost__userInfo__N6yNd","text":"InsightPost__text__fBzvL","attach":"InsightPost__attach__T9S9E"};